// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_Bz1DI","stock_box":"index_stock_box_a90B3"};